export default __webpack_public_path__ + "static/media/send.41ce65df.svg";